import moment from "moment";
import jpath from 'jsonpath';

import AddressCellRenderer from '@/components/CX/Grid/AddressCellRenderer';
import LinkCellRenderer from '@/components/CX/Grid/LinkCellRenderer';
import ImageCellRenderer from "@/components/CX/Grid/ImageCellRenderer";
import CXScoreCellRenderer from "@/components/CX/Grid/CXScoreCellRenderer";
import StarCellRenderer from "@/components/CX/Grid/StarCellRenderer";
import FlagCellRenderer from '@/components/CX/Grid/FlagCellRenderer';
import PercentCellRenderer from '@/components/CX/Grid/PercentCellRenderer';

export default {
  data() {
    return {
      columnDefs: [
        { 
          width: 100, 
          headerName: "Details", 
          cellRenderer: 'linkCellRenderer' 
        // }, { 
        //   headerName: "Country", 
        //   field: "CountryId", 
        //   rowGroup: true, 
        //   hide: true, 
        //   suppressFiltersToolPanel: true 
        }, { 
          headerName: "Image", 
          field: "ClientLocationId", 
          sortable: false, 
          autoHeight: true, 
          cellRenderer: 'imageCellRenderer' 
        }, { 
          width: 270, 
          resizable: true, 
          headerName: "Location", 
          field: "Name", 
          floatingFilter: true,
          cellRenderer: 'addressCellRenderer'
        }, { 
          resizable: true, 
          headerName: "Name", 
          field: "Name", 
          hide: true 
        }, { 
          resizable: true, 
          headerName: "City", 
          field: "City", 
          hide: true 
        }, { 
          resizable: true, 
          headerName: "Postal Code", 
          field: "PostalCode", 
          hide: true 
        }, { 
          resizable: true, 
          floatingFilter: true,
          headerName: "Location Id", 
          field: "CustomLocationId" 
        }
      ],
      // $..Explorations[?(@.type=="home")]

      customColumns: {
        active: [],
        // TODO: Die Info's müssen später länderspezifisch aus einer API kommen.
        // Und in das Checkboxcontrol gebunden werden
        items: [
          // 7 Column
          { 
            group: 'Process Excellence', 
            key: 'Process Excellence',                 
            indent: 0, 
            text: 'Process Excellence', 
            isHeader: true 
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Contact',  
            indent: 1, 
            text: 'Contact',
            path: '$.FocusKPI[?(@.KpiCode=="Follow-up")].SurveyWave',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Sales Consultation',  
            indent: 1, 
            text: 'Sales Consultation',
            path: '$.FocusKPI[?(@.KpiCode=="Customer Treatment")].SurveyWave',
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Offer',  
            indent: 1, 
            text: 'Offer',
            path: '$.FocusKPI[?(@.KpiCode=="Responsetime")].SurveyWave',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Contact Care',  
            indent: 1, 
            text: 'Contact Care',
            path: '$.FocusKPI[?(@.KpiCode=="Measures")].SurveyWave',
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY', "Current Value", true)
          },
          { 
            group: '2', 
            key: '2',                 
            indent: 0, 
            text: 'Focus KPI', 
            isHeader: true
          }, { 
            group: '2', 
            key: '2.Process Excellence',                 
            indent: 1, 
            text: 'Process Excellence', 
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, { 
            group: '2', 
            key: '2.Lead Follow Up',                 
            indent: 1, 
            text: 'Lead Follow Up', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, 'percent', null, 'MMMM YYYY', "Current Value", true)
          },{ 
            group: '2', 
            key: '2.Appointment Follow Up',
            indent: 1, 
            text: 'Appointment Follow Up', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },{ 
            group: '2', 
            key: '2.LMTD',
            indent: 1, 
            text: 'LM: Test Drive', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },{ 
            group: '2', 
            key: '2.LMIO',
            indent: 1, 
            text: 'LM: Integrated Offer', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },{
            group: '2', 
            key: '2.xEV Readiness',  
            indent: 1, 
            text: 'xEV Readiness',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },{
            group: '2', 
            key: '2.My BMW App',  
            indent: 1, 
            text: 'My BMW/MINI App',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },{
            group: '2', 
            key: '2.MYSCT',  
            indent: 1, 
            text: 'MYS Customer Treatment',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },

          // Specific Model-KPI
          { 
            group: '3', 
            key: '3',                 
            indent: 0, 
            text: 'Specific Model-KPI', 
            isHeader: true
          }, {
            group: '3', 
            key: '3.xEV Readiness',  
            indent: 1, 
            text: 'xEV Readiness',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          }, {
            group: '3', 
            key: '3.GKL+',  
            indent: 1, 
            text: 'GKL+',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },

          // Specific Evaluations
          { 
            group: '4', 
            key: '4',
            indent: 0, 
            text: 'Specific Evaluations', 
            isHeader: true
          }, {
            group: '4', 
            key: '4.Excitement Rating',  
            indent: 1, 
            text: 'Excitement Rating',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          }, {
            group: '4', 
            key: '4.Digital Readiness',  
            indent: 1, 
            text: 'Digital Readiness',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          }, {
            group: '4', 
            key: '4.Legendary Moments',  
            indent: 1, 
            text: 'Legendary Moments',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          }, {
            group: '4', 
            key: '4.Shops',  
            indent: 1, 
            text: '#Shops',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY', "Current Value", true)
          },

          // 1 Column
          { 
            group: 'Exploration', 
            key: 'Exploration.Reviews', // Unique Key in der Liste       
            text: 'Reviews',              // Text der Checkbox / der Überschrift
            indent: 0,
            isHeader: true  // Das heißt anstatt einer Checkbox wird ein Label gerendert
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Reviews.Google',      
            text: 'Google',
            path: '$.Explorations.Google',
            indent: 1,  
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY')   
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Reviews.Mobile',      
            indent: 1, 
            text: 'Mobile.de', 
            // path: '$.Explorations.Mobile_de',
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY')
          }, { 
            group: 'Exploration',
            key: 'Exploration.Reviews.Autoscout24',
            indent: 1,
            text: 'AutoScout 24',
            // path: '$.Explorations.Autoscout24',
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY')
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Seobility',     
            indent: 0, 
            text: 'Search Engine Optimization', 
            isHeader: true 
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Seobility_en',  
            indent: 1, 
            text: 'Seobility - Corporate Website',
            // path: '$.Explorations.Seobility',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Seobility2_en', 
            indent: 1, 
            text: 'Seobility - Retailer Website',
            // path: '$.Explorations.Seobility2',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          },

          // 2 Column
          { 
            group: 'WebPresence', 
            key: 'WebPresence',     
            indent: 0, 
            text: 'Web Presence', 
            isHeader: true 
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.Corporate',  
            indent: 1, 
            text: 'Corporate',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Web Presence - Corporate Website")].Waves',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.Retailer', 
            indent: 1, 
            text: 'Retailer',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Web Presence - Retailer Website")].Waves',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.GoogleMyBusiness',     
            indent: 0, 
            text: 'Google My Business', 
            isHeader: true 
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.GoogleMyBusiness.GoogleMyBusiness',  
            indent: 1, 
            text: 'Google My Business',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Google My Business")].Waves',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.SocialMediaPresence',     
            indent: 0, 
            text: 'Social Media Presence', 
            isHeader: true 
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.SocialMediaPresence.Facebook',  
            indent: 1, 
            text: 'Facebook',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Social Media Presence - Facebook")].Waves',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.SocialMediaPresence.Instagram', 
            indent: 1, 
            text: 'Instagram',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Social Media Presence - Instagram")].Waves',
            columns: this.generateColumns(4, null, 'percent', 'MMMM YYYY')
          }
        ]
      },

      defaultColDef: {
        width: 170,
        sortable: true,
        filter: true,
        suppressMovable: true,
        enableRowGroup: false,
        menuTabs: ['generalMenuTab', 'filterMenuTab']
      },

      gridOptions: { 
        suppressAggFuncInHeader: true,
        onGridReady: (event) => event.api.autoSizeAllColumns(),  },
    }
  },

  components: { 
    addressCellRenderer: AddressCellRenderer,
    imageCellRenderer: ImageCellRenderer,
    linkCellRenderer: LinkCellRenderer,
    cxScoreCellRenderer: CXScoreCellRenderer,
    starCellRenderer: StarCellRenderer,
    percentCellRenderer: PercentCellRenderer,
    flagCellRenderer: FlagCellRenderer
  },

  methods: {
    generateColumns(count, renderer, valueFormat, dateFormat, firstColHeader = "Current Value", fixQuarter = false) {
      let items = [];
      for (let i = 0; i < count; i++) {
        let newItem = {
          show: i === 0 ? "always" : "open",
          filter: true,
          render: renderer,
          format: valueFormat,
          text: i === 0 ? firstColHeader : moment().subtract(i, "month").format(dateFormat) 
        };

        if (fixQuarter && i > 0) {
          switch (i) {
            case 1:
              newItem.text = 'Q1 2022';
              break;
            case 2:
              newItem.text = 'Q4 2021';
              break;
            case 3:
              newItem.text = 'Q3 2021';
              break;
            default:
              break;
          }    
          newItem.text
        }

        items.push(newItem);
      }
      return items;
    },

    percentValueFormatter(params) {
      return params.value ? params.value + "%" : "";
    },

    minMaxAggregation(params) {
      let min = params.values.filter(x => x !== undefined && x !== null).sort()[0];
      let max = params.values.filter(x => x !== undefined && x !== null).reverse()[0];
      if (min === undefined && max === undefined) return '';
      if (min === undefined) min = '';
      if (max === undefined) max = '';
      return `${min} ... ${max}`;
    },

    mixinGetColumn(arg, columns) {
      let item = columns
        ? columns.items.find(x => x.key == arg)
        : this.customColumns.items.find(x => x.key == arg);

      if (item?.isHeader) {
        // console.warn(`Header (it should not call): ${item.key}`);
        return;
      }

      if (!item?.path) {
        // console.warn(`No path: ${item.key}`);
        return;
      }
      let result = { headerName: item.text, children: [] };
      for (let i = 0; i < item.columns.length; i++) {
        const col = item.columns[i];
        
        let column = {  
          valueGetter: (params) => { 
            try {
              if (!params.data) return;
             
              let rowProperty = jpath.query(params.data, item.path);
              if (!Array.isArray(rowProperty)) return rowProperty;
              if (!rowProperty || rowProperty.length !== 1) return;
              if (Number(rowProperty[0]) === rowProperty[0] || _.isString(rowProperty[0]) || rowProperty[0] === null) return rowProperty[0];
              
              let rowResult = item.columns.length == 1 ? rowProperty[0] : rowProperty[0][i];
              if (!rowResult) return; 
              if (item.path.includes('$.Kpi[?(@.KpiGroupCode=="Excitement" && @.KpiCode==null)]')) {
                return (rowResult.Result / 20).toFixed(1);
              }

              if (rowResult?.value === undefined && 
                  rowResult?.WaveResult === undefined && 
                  rowResult?.QuestionResult === undefined && 
                  rowResult?.Result === undefined) {
                // console.warn(rowResult)
              }
              return rowResult?.value 
                  || rowResult?.WaveResult 
                  || rowResult?.QuestionResult 
                  || rowResult?.Result;
            } catch (error) {
              console.warn(error)
              return `Path N/A!: ${col.key}`;
            }
          },
          aggFunc: null, // this.minMaxAggregation,
          cellRenderer: col.render ? `${col.render}CellRenderer` : null,
          field: `[${col.key}][${i}].value`, 
          headerName: col.text,
          columnGroupShow: col.show,
          floatingFilter: col.filter ? col.filter : false,
          valueFormatter: col.format ? this[`${col.format}ValueFormatter`] : null
        };
        result.children.push(column);
      }
      return result;
    }
  }
}
